export default __webpack_public_path__ + "static/media/travelIns2.6bc29766.jpg";